import { useEffect, useState } from "react";
import "./style.scss";
import { Button } from "@/components";
import Checkbox from "@/components/CheckBox";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import z from "zod";

type LocationKey = "merchant" | "admin" | "lams";

const location_urls: Record<LocationKey, string> = {
  merchant: "https://merchant-portal.pluritongues.com/",
  admin: "https://admin.pluritongues.com/",
  lams: "https://lams.pluritongues.com/",
};

const passwordSchema = z
  .object({
    password: z
      .string()
      .min(8)
      .regex(/[a-zA-Z]/, "Password must contain at least one letter")
      .regex(/[0-9]/, "Password must contain at least one number")
      .regex(/[^a-zA-Z0-9]/, "Password must contain at least one special character"),
    confirmPassword: z.string().min(1, "Confirm password is required"),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });
export default function NewPassword() {
  const navigate = useNavigate();

  const [password, setPassword] = useState<string>("");
  const [reEnterPassword, setReEnterPassword] = useState<string>("");

  const [inputType, setInputType] = useState<string>("password");
  const [secondInputType, setSecondInputType] = useState<string>("password");

  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showSecondPassword, setShowSecondPassword] = useState<boolean>(false);

  const [error, setError] = useState<boolean>(false);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [check, setCheck] = useState({
    minLength: false,
    hasLetter: false,
    hasNumber: false,
    hasSpecial: false,
  });

  const result = passwordSchema.safeParse({
    password,
    confirmPassword: reEnterPassword, // dummy, we only care about password field
  });
  function getPasswordStatus(password: string) {
    const feedback: string[] = [];

    if (!result.success) {
      const passwordErrors = result.error.issues.filter((issue) => issue.path[0] === "password");

      passwordErrors.forEach((issue) => {
        feedback.push(issue.message);
      });
    }

    const checks = {
      minLength: password.length >= 8,
      hasLetter: /[a-zA-Z]/.test(password),
      hasNumber: /[0-9]/.test(password),
      hasSpecial: /[^a-zA-Z0-9]/.test(password),
    };
    setCheck({ ...check, ...checks });

    return {
      isValid: result.success,
      // feedback,
      checks,
    };
  }

  useEffect(() => {
    getPasswordStatus(password);
  }, [password]);

  const handleToggle = () => {
    setShowPassword(!showPassword);
    setInputType(showPassword ? "password" : "text");
  };

  const handleSecondToggle = () => {
    setShowSecondPassword(!showSecondPassword);
    setSecondInputType(showSecondPassword ? "password" : "text");
  };

  const handleSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    const emailValue = localStorage.getItem("email");
    const otpValue = localStorage.getItem("otp");
    setIsLoading(true);

    const payload = {
      email: emailValue,
      password: password,
      otp: otpValue,
    };
    if (password === reEnterPassword) {
      try {
        const response = await fetch("https://core.pluritongues.com/auth/reset-password", {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          const data = await response.json();
          toast.success("Password reset successfully, Please Login");
          localStorage.removeItem("otp");
          localStorage.removeItem("email");

          const redirect_to_type = localStorage.getItem("from");
          let to_url = "/";
          if (redirect_to_type && redirect_to_type !== "null") {
            if (["merchant", "admin", "lams"].includes(redirect_to_type)) {
              to_url = location_urls[redirect_to_type as LocationKey];
            }
          }
          window.location.href = to_url;
        } else {
          const errorData = await response.json();
          toast.error(errorData.message || "something went wrong please try again");
        }
      } catch (err) {
        toast.error("An error occurred. Please try again.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
      toast.warning("The passwords you entered don't match. Please try again.", {
        richColors: true,
      });
    }
  };

  const values = Object.values(check);
  return (
    <div className="new-password-layout">
      <div className="new-password-sidebar">
        <h1 className="new-password-sidebar-h1">Create a new password</h1>
        <p className="new-password-sidebar-p">
          Save your new password in a secure place. If you forget your password again, you will have
          to do a forgot password again.
        </p>
        <ul></ul>

        <form onSubmit={handleSubmit} className="new-password-form-wrapper">
          <div>
            <label className="new-password-label">Password</label>
            <div className="passBoxes">
              <input
                type={inputType}
                className="new-password-input"
                placeholder="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
              <span onClick={handleToggle} className="new-password-show-toggle">
                {showPassword ? <p>Hide</p> : <p>Show</p>}
              </span>
            </div>
            <div className="theBox">
              <div
                className={`
               ${
                 values?.filter((v) => v === true).length === 1
                   ? "red"
                   : values.filter((v) => v === true).length === 2 ||
                     values.filter((v) => v === true).length === 3
                   ? "orange"
                   : values.filter((v) => v === true).length === 4 && "green"
                 //  : password.length && values?.filter((v) => v === true).length < 1 && "lines"
               }
               lines`}
              ></div>
              <div
                className={`${
                  values.filter((v) => v === true).length === 2 ||
                  values.filter((v) => v === true).length === 3
                    ? "orange"
                    : values.filter((v) => v === true).length === 4 && "green"
                } lines`}
              ></div>
              <div
                className={`${values.filter((v) => v === true).length === 4 && "green"} lines`}
              ></div>
            </div>
          </div>
          <div>
            <label className="new-password-label">Confirm password</label>
            <div className="passBoxes">
              <input
                className="new-password-second-input"
                type={secondInputType}
                value={reEnterPassword}
                placeholder="password"
                onChange={(e) => setReEnterPassword(e.target.value)}
              />
              <span onClick={handleSecondToggle} className="new-password-show-second-toggle">
                {showSecondPassword ? <p>Hide</p> : <p>Show</p>}
              </span>
            </div>
          </div>

          {error && <div className="new-password-error">{error}</div>}

          <Button
            variant="primary"
            isLoading={isLoading}
            className="new-password-btn"
            disabled={isLoading}
          >
            Continue
          </Button>
        </form>
      </div>

      <div className="new-password-bg-body"></div>
    </div>
  );
}
